module.exports = __webpack_public_path__ + "img/setting.e4fc96bd.png";